var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9494_16522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3326 20.48C27.2237 20.48 31.9993 15.8954 31.9993 10.24C31.9993 4.5846 27.2237 0 21.3326 0C15.4416 0 10.666 4.5846 10.666 10.24C10.666 15.8954 15.4416 20.48 21.3326 20.48Z",
    fill: "#FFDE2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 20.48C16.5576 20.48 21.3333 15.8954 21.3333 10.24C21.3333 4.5846 16.5576 0 10.6666 0C4.77561 0 0 4.5846 0 10.24C0 15.8954 4.77561 20.48 10.6666 20.48Z",
    fill: "#327EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3327 10.24C21.3327 15.8954 16.5571 20.4799 10.666 20.4799V10.24H21.3327ZM10.666 10.24C10.666 4.5846 15.4417 0 21.3327 0V10.24H10.666Z",
    fill: "#FF6446"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9494_16522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20.48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo25);
export default __webpack_public_path__ + "static/media/logo25.243795be44c67cd39872f368a3afb4e0.svg";
export { ForwardRef as ReactComponent };